// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ky-3";
export var downloadButton = "_ky-4";
export var fileContainer = "_ky-9 _ky-7";
export var fileContainerBase = "_ky-7";
export var fileContainerBaseSm = "_ky-a _ky-7";
export var fileContainerFixedHeight = "_ky-8 _ky-7";
export var fileContainerFixedHeightSm = "_ky-c _ky-a _ky-7";
export var fileContainerSm = "_ky-b _ky-a _ky-7";
export var fileInfo = "_ky-5";
export var fileInfoWidthRestricted = "_ky-6";
export var fileType = "_ky-1";
export var fileTypeName = "_ky-2";
export var fileTypeSm = "_ky-d _ky-1";
export var image = "_ky-0";
export var link = "_ky-f";
export var overflowEllipsis = "_ky-e";